import React from 'react';

import { ColumnsV2, ColumnsV2Props } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';
import { StyledBoxBrannan } from './Frames.styles';

const FrameOuter: React.FC<HtmlProps<HTMLElement> & { applicatorProp: object; loading: boolean }> = ({ applicatorProp, children, loading, ...restProps }) => {
  return (
    <StyledBoxBrannan
      loading={loading}
      {...applicatorProp}
      overflow={'hidden'}
      transition={animationTransition('background', 'background-color')}
      data-testid={'outer-frame'}
      {...restProps}
      position={'relative'}
    >
      {children}
    </StyledBoxBrannan>
  );
};

const FrameInner: React.FC<HtmlProps<HTMLElement> & ColumnsV2Props> = ({ children, ...restProps }) => {
  return (
    <ColumnsV2 fluid={true} maxWidth={[null, null, 1024]} {...restProps}>
      <ColumnsV2.Column data-testid={'inner-frame'}>{children}</ColumnsV2.Column>
    </ColumnsV2>
  );
};

export { FrameOuter, FrameInner };
